// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { CustomerProjectFiltersContextType } from '@/customer/contexts/customer-project-filters-context.types';
import { createContext, useContext } from 'react';

export const CustomerProjectFiltersContext = createContext<
  CustomerProjectFiltersContextType | undefined
>(undefined);

export const useCustomerProjectFilters = () => {
  const context = useContext(CustomerProjectFiltersContext);
  if (!context) {
    throw new Error(
      'useCustomerProjectFilters must be used within a CustomerProjectFiltersProvider'
    );
  }
  return context;
};
